import React from 'react';

import * as CONSTANTS from "../constants";

import OrderSummary from '../components/order-summary';
import IFrame from '../components/iframe';

const iframeURL = `${CONSTANTS.DOMAIN_NAME}/${CONSTANTS.CLIENT_NAME}/website/secure/MyAccount.aspx?resize=true`;

export default function IframeAccount() {

    return (
        <div className='booking-pathway__container booking-pathway__iframe-account'>
            
            <div className='booking-pathway__main-content'>
                <h1 className='sr-text'>Account</h1>
                <IFrame url={iframeURL} title="Account" hasLoader="true" />
            </div>
        </div>
    );
}